import React, { Suspense } from 'react';
import { Switch, Route, BrowserRouter } from 'react-router-dom';
import 'nprogress/nprogress.css';
import nProgress from 'nprogress';
import {
  USER_BASE_PATH,
  ADMIN_PATH,
  SIGNIN_PATH,
  FORGOT_PASSWORD_PATH,
  END_USER_LANDING_PATH,
  PAGE_NOT_FOUND_PATH,
  DOCUMENT_VIEW_PATH,
  DOCUMENT_PREVIEW_PATH,
  PASSWORDUPDATE_PATH,
  PAYMENT_PAGE,
} from './utils/AppRoutes';

//Components
import Signin from './components/Signin';
import AdminRouteControl from './components/admin/layout/AdminRouteControl';
import { Provider } from 'react-redux';
import AppLayout from './components/appLayout';
import ForgotPassword from './components/forgotPassword';
import configureStore from './redux/store/ConfigureStore';
import LandingPage from './components/endUser/LandingPage';
import CustomPageNotFound from './components/common/CustomPageNotFound';
import ViewDocument from './components/documents/viewDocument';
import PreviewDocument from './components/documents/previewDocument';
import { PublicRoute, ProtectedRoute } from './utils/functions/CoreFunctions';
import UpdatePassword from './components/UpdatePassword';
import GeneralLandingPage from './components/GeneralLandingPage';
import PaymentScreen from './components/endUser/InvoicePayment/PaymentScreen';
import './Style/Common.css';

nProgress.configure({ showSpinner: false });
const store = configureStore();

const App = () => {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Suspense
          fallback={
            <center>
              <p>Loading...</p>
            </center>
          }
        >
          <Switch>
            {/* Admin Path Controls */}
            <ProtectedRoute path={ADMIN_PATH} component={AdminRouteControl} />
            {/* Admin Path Controls */}

            {/* User Path Controls */}
            <PublicRoute
              exact
              path={USER_BASE_PATH}
              component={GeneralLandingPage}
            />
            <PublicRoute exact path={SIGNIN_PATH} component={Signin} />
            <PublicRoute
              exact
              path={FORGOT_PASSWORD_PATH}
              component={ForgotPassword}
            />
            <ProtectedRoute
              exact
              path={PASSWORDUPDATE_PATH}
              component={UpdatePassword}
            />
            <Route path={END_USER_LANDING_PATH} component={LandingPage} />
            <Route path={PAYMENT_PAGE} component={PaymentScreen} />
            <ProtectedRoute
              exact
              path={DOCUMENT_VIEW_PATH}
              component={ViewDocument}
            />
            <ProtectedRoute
              exact
              path={DOCUMENT_PREVIEW_PATH}
              component={PreviewDocument}
            />

            <ProtectedRoute path={USER_BASE_PATH + '*'} component={AppLayout} />
            {/* User Path Controls */}

            <Route path={PAGE_NOT_FOUND_PATH} component={CustomPageNotFound} />
          </Switch>
        </Suspense>
      </BrowserRouter>
    </Provider>
  );
};

export default App;
